import { object } from 'yup';
import { TFunction } from 'i18next';

import { requiredPhoneObjectField, requiredVerificationCodeField } from 'common/validation';

export function makePhoneSchema(t: TFunction) {
  return object().shape({
    phone: requiredPhoneObjectField(t),
  });
}

export function makeCodeSchema(t: TFunction) {
  return object().shape({
    code: requiredVerificationCodeField(t),
  });
}
